export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <img src="/logo-sollus.png" alt="" className="h-10 w-auto" />
    <span className="leading-none">
      <span className={`block font-display text-[26px] font-bold tracking-[0.06em] ${light ? "text-white" : "text-navy"}`}>SOLLUS</span>
      <span className={`block text-[9px] font-semibold uppercase tracking-[0.22em] ${light ? "text-white/70" : "text-steel"}`}>Máquinas e Implementos</span>
    </span>
  </span>
);
